// Page registry — the single source of truth for which pages exist and where
// they live. The backend nav config (nav_items.page_key) references these keys;
// the admin nav tool arranges *registered* pages, it never invents new ones.
// Adding a genuinely new page still means: add its component + <Route> in
// App.js and an entry here, after which it becomes placeable in the nav editor.
//
// `label` is a sensible default; the actual nav label comes from the DB nav
// config (editable) and falls back to this only if missing.

export const PAGE_REGISTRY = {
  home:              { path: '/',                         label: 'DemandArc' },
  programs:          { path: '/programs',                 label: 'Programs' },
  // Admin-only creation wizard. Registered so GuardedRoute/canAccess can gate it,
  // but deliberately never placed in the nav — it is reached from the Programs page.
  'program-new':     { path: '/programs/new',             label: 'New Program' },
  components:        { path: '/components',               label: 'Components' },
  goals:             { path: '/goals',                    label: 'Goals' },
  'program-documents': { path: '/program-documents',     label: 'Program Documents' },
  'lead-upload':     { path: '/lead-upload',              label: 'Lead Status Updater' },
  'lead-qa':         { path: '/lead-qa',                  label: 'Lead QA Review' },
  'qa-rules':        { path: '/qa-rules',                 label: 'Campaign QA Rules' },
  'lead-delivery':   { path: '/lead-delivery',            label: 'Client Leads Delivery' },
  'lead-delivery-setup': { path: '/lead-delivery-setup',  label: 'Delivery Setup' },
  // Registered so GuardedRoute/canAccess can gate it, but deliberately never
  // placed in the nav — reached only from a My Home "Client delivery" task or
  // Lead QA Review's "⬇ Accepted ▾" menu, same precedent as program-new above.
  'client-delivery-wizard': { path: '/client-delivery-wizard', label: 'Client Delivery Wizard' },
  'supplier-portal': { path: '/supplier-portal',          label: 'Supplier Deliveries' },
  'pm-home':         { path: '/pm-home',                  label: 'My Home' },
  'week-glance':     { path: '/week-at-a-glance',          label: 'Week at a Glance' },
  invoices:          { path: '/invoices',                 label: 'Invoices' },
  'reports-billable-supplier': { path: '/reports/billable-by-supplier', label: 'Billable Leads by Supplier' },
  'reports-billable-client':   { path: '/reports/billable-by-client',   label: 'Billable Leads by Client' },
  'reports-revenue':           { path: '/reports/revenue',              label: 'Revenue Recognition' },
  'targeting-lists': { path: '/targeting-lists',          label: 'List Management' },
  suppliers:         { path: '/suppliers',                label: 'Suppliers' },
  clients:           { path: '/clients',                  label: 'Clients' },
  products:          { path: '/products',                 label: 'Products' },
  admin:             { path: '/admin',                    label: 'Admin' },
  'email-alerts':    { path: '/admin/email-alerts',       label: 'Email Alerts' },
  'component-library': { path: '/admin/component-library', label: 'Component Library' },
  navigation:        { path: '/admin/navigation',         label: 'Navigation' },
  'recycle-bin':     { path: '/admin/recycle-bin',        label: 'Recycle Bin' },
  'system-health':   { path: '/admin/system-health',      label: 'System Health' },
  'global-opt-outs': { path: '/admin/opt-outs',           label: 'DNE / DNC from Emails' },
  'backlog-queue':   { path: '/admin/backlog-queue',       label: 'Backlog Queue' },
  // ContentIQ (admin-only pilot): backend migration 0079 seeds a 'ContentIQ'
  // nav group with both pages, roles=['admin'] only.
  contentiq:         { path: '/contentiq',                label: 'ContentIQ Home' },
  'contentiq-admin': { path: '/contentiq/admin',          label: 'ContentIQ Config' },
  'contentiq-assets': { path: '/contentiq/assets',        label: 'Content Assets' },
  'contentiq-builds': { path: '/contentiq/builds',        label: 'Landing Page Builds' },
};

// Convenience for the nav editor's "add a page" picker.
export const REGISTERED_PAGES = Object.entries(PAGE_REGISTRY).map(
  ([key, { path, label }]) => ({ key, path, label })
);
